import React from "react";
import MainMenu from "./MainMenu";


export default function AdminLayout() {
    return (
        <div>
            <div className="medicare-brand">
                <div className="medicare-brand-icon">
                    <i className="fa fa-stethoscope" aria-hidden="true"></i>
                </div>

                <div className="medicare-brand-text">
                    <span className="medicare-brand-name">
                        MediCare
                    </span>

                    <span className="medicare-version">
                        2.0
                    </span>

                    <span className="medicare-tagline">
                        Smart Healthcare Management
                    </span>
                </div>
            </div>
            <div style={{ marginTop: '10px' }}>
                <MainMenu />
            </div>
        </div>
    )
}
